import { NavLink } from "react-router-dom";

const TABS = [
  { to: "/", label: "Home" },
  { to: "/grids", label: "Grids" },
  { to: "/wind", label: "Wind" },
  { to: "/activity", label: "Activity" },
] as const;

/** Bottom tab bar — 3 NavLinks styled as legacy pill-btn tabs. */
export default function TabBar() {
  return (
    <nav className="flex gap-2 px-4 py-2 bg-surface border-b border-border flex-shrink-0">
      {TABS.map(({ to, label }) => (
        <NavLink key={to} to={to} end={to === "/"}>
          {({ isActive }) => (
            <span
              className={[
                "px-4 py-1.5 rounded text-sm font-medium border cursor-pointer transition-colors",
                isActive
                  ? "bg-success/10 border-success text-success"
                  : "border-border text-muted hover:border-dim hover:text-text",
              ].join(" ")}
            >
              {label}
            </span>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
